module.exports = __webpack_public_path__ + "img/93980.3fae7e55.svg";